import { CustomGroup } from './LinkItemsPage';

export const disabledResetButton = (
  isEqualLinkedItems: boolean,
  isInitStateLinkedGroups: boolean
): boolean => {
  return isEqualLinkedItems || isInitStateLinkedGroups;
};

/**
 * @NOTE
 * 本来はこの関数を使わずにexternalItemIdだけで比較を行っていたが、商品の複製に失敗をした場合にexternalItemIdがユニークでなくなり、 商品を追加できなくなってしまう。
 * storeIdと繋げて一意性を保つようにして対処をする。
 * **/
export const uniqueLinkedStoreItemId = (
  externalItemId: string,
  storeId: string,
  itemName: string
): string => {
  return `${externalItemId}_and_${storeId}_and_${itemName}`;
};

export const disabledSubmitButton = (
  linkedGroups: CustomGroup[],
  initialLinkedGroup: CustomGroup[],
  isDisabledResetButton: boolean
): boolean => {
  return (
    linkedGroups.some((group) => {
      return (
        (group.validate?.groupName.isInputed &&
          group.validate?.groupName.isMax) ||
        group.validate?.groupName.isBlank ||
        (group.linked_store_items.length === 0 && !group.isTentativeDelete) ||
        isDisabledResetButton
      );
    }) ||
    // 初期から0件でグループが0のままであればdisabled
    (initialLinkedGroup.length === 0 && linkedGroups.length === 0)
  );
};

/**
 * stringをもつカラムで昇順をする。
 * 他のページ等でも使えそうなので移動をしてもいいかも。
 * [MEMO] toUpperCaseで厳密なソートをするようにしている。
 * */
export const ascSortAtStringValue = <T, K extends keyof T>(
  arr: T[],
  targetkey: K
): T[] => {
  return arr.sort((objA, objB) => {
    const targetValueA = (objA[targetkey] as unknown as string).toUpperCase();
    const targetValueB = (objB[targetkey] as unknown as string).toUpperCase();
    if (targetValueA < targetValueB) {
      return -1;
    }
    if (targetValueA > targetValueB) {
      return 1;
    }
    return 0;
  });
};
